module.exports = __webpack_public_path__ + "static/media/MIA_Logo_Official_1000x.e16738c8.png";